import {makeStyles} from "@material-ui/core/styles";
import React from "react";
import * as axios from "axios";
import "./styles.css"

const useStyles = makeStyles({
  card: {
    maxWidth: 345,
  },
  media: {
    height: 140,
  },
});

export default class InfoClient extends React.Component {
  state = {
    orderId: '',
    phone: '',
    addresses: [],
    user: {},
    orders: [],
    loading: false,
  };

  componentDidMount() {
    const orderId = new URLSearchParams(this.props.location.search).get('orderId');
    if (orderId) {
      this.setState({orderId}, this.search);
    }
  }

  search = async () => {
    // const baseUrl = 'http://localhost:8080/';
    const baseUrl = 'https://api.appetito.ro/';
    const token = localStorage.getItem('access_token');
    this.setState({loading: true})
    const response = await axios.default.get(`${baseUrl}v1/admin/client-info/${this.state.orderId}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    this.setState({...response.data, loading: false})
  }

  searchPhone = async () => {
    // const baseUrl = 'http://localhost:8080/';
    const baseUrl = 'https://api.appetito.ro/';
    const token = localStorage.getItem('access_token');
    this.setState({loading: true})
    const response = await axios.default.get(`${baseUrl}v1/admin/client-info-phone/${this.state.phone}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    this.setState({...response.data, loading: false})
  }

  formatDate = (timestamp) => {
    let date = this.convertUTCDateToLocalDate(timestamp);
    let hours = date.getHours();
    let minutes = date.getMinutes();
    return date.toLocaleDateString() + ` ${hours}:${minutes}`;
  };

  convertUTCDateToLocalDate(date) {
    const dateLocal = new Date(date);
    return dateLocal//new Date(dateLocal.getTime() - dateLocal.getTimezoneOffset() * 60 * 1000);
  }

  formatAddress(address) {
    return `Str. ${address.street}, 
    ${address.number !== '' ? 'nr. ' + address.number + ', ' : ''}
    ${address.apartment !== '' ? ', ap. ' + address.apartment + ', ' : ''}
    ${address.floor !== '' ? ', etaj ' + address.floor + ', ' : ''}
    ${address.details}, ${address.city}
    `
  }

  render() {
    const orders = this.state.orders || [];
    const addresses = this.state.addresses || [];
    const user = this.state.user || {};
    return (
      <>
        {!this.state.loading && <div className={'info-client-container'}>
          <div className={'title'}>
            Id comandă <input
            value={this.state.orderId}
            onChange={(event) => {
              if (event.target.value.length > 7) {
                return
              }
              this.setState({orderId: event.target.value});
            }}
            onKeyPress={(event) => {
              if (!/[0-9]/.test(event.key)) {
                event.preventDefault();
              }
            }}
            className={'input'}/>
            <button className={'searchButton'}
                    onClick={this.search}>
              Caută
            </button>
          </div>
          <div className={'title2'}>
            Nr telefon <input
            style={{width: 100}}
            value={this.state.phone}
            onChange={(event) => {
              if (event.target.value.length > 12) {
                return
              }
              this.setState({phone: event.target.value});
            }}
            onKeyPress={(event) => {
              if (!/[0-9]/.test(event.key)) {
                event.preventDefault();
              }
            }}
            className={'input'}/>
            <button className={'searchButton'}
                    onClick={this.searchPhone}>
              Caută
            </button>
          </div>
          {(user.id) && <>
            <div style={{fontSize: 30, fontWeight: 800, marginTop: 50}}>{user.first_name + " " + user.last_name}</div>
            {user.verification_code !== "" && <div>Vă rugăm să folosiți următorul cod: {user.verification_code} expira la {user.verification_code_expire}</div>}
            <div>{user.phone}</div>
            <div>{user.email}</div>
            <div>{"Data adaugare: " + this.formatDate(user.created)}</div>
            {user.deleted && <div style={{fontSize: 30, fontWeight: 800, color: '#ff0000'}}>{"Dezactivat"}</div>}
          </>
          }
          <div style={{marginTop: 50, fontSize: 30, fontWeight: 800}}>Adrese</div>
          <table className="info-client-table" style={{
            borderSpacing: 0
          }}>
            <thead>
            <tr>
              <th style={{width: 60, }}>Id</th>
              <th
                style={{width: 400, }}>Adresa
              </th>
              <th
                style={{width: 450, }}>Mentiuni
              </th>
            </tr>
            </thead>
            <tbody>
            {addresses.map((address, i) => {
              return (
                <tr key={address.id || i}>
                  <td style={{
                    textAlign: 'center',
                  }}>{address.id}</td>
                  <td style={{
                    textAlign: 'center',
                  }}>{this.formatAddress(address)}</td>
                  <td style={{
                    textAlign: 'center',
                  }}>{address.description}</td>
                </tr>
              )
            })}
            </tbody>
          </table>
          <div style={{fontSize: 30, fontWeight: 800, marginTop: 50}}>Comenzi</div>
          <div style={{display: 'inline-table', position: 'relative', paddingBottom: 80}}>
            <table className="info-client-table" style={{
              display: 'inline-table',
              borderSpacing: 0
            }}>
              <thead>
              <tr>
                <th style={{width: 60, }}>Id</th>
                <th style={{width: 130, }}>Data
                </th>
                <th
                  style={{
                    width: 100,
                  }}>Restaurant
                </th>
                <th style={{width: 70, }}>Id
                  Adresă
                </th>
                <th
                  style={{width: 300, }}>Mențiuni
                </th>
                <th
                  style={{width: 300, }}>Mențiuni
                  puse de noi
                </th>
              </tr>
              </thead>
              <tbody>
              {orders.map((order, i) => {
                return (
                  <tr key={order.id || i}>
                    <td style={{
                      textAlign: 'center',
                    }}>{order.id}</td>
                    <td style={{
                      textAlign: 'center',
                    }}>{this.formatDate(order.created)}</td>
                    <td style={{
                      textAlign: 'center',
                    }}>{order.restaurant}</td>
                    <td style={{
                      textAlign: 'center',
                    }}>{order.addressId}</td>
                    <td style={{
                      textAlign: 'center',
                    }}>{order.mentions}</td>
                    <td style={{
                      textAlign: 'center',
                    }}>{order.ourMentions}</td>
                  </tr>
                )
              })}
              </tbody>
            </table>
          </div>
        </div>}
        {this.state.loading &&
        <div className={'loader-container'}>
          <div className={'loader'}/>
        </div>}
      </>
    )
  }
}